// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './element-#232021/index.css'
import './assets/iconfont/iconfont.css'
// import VueLazyLoad from 'vue-lazyload'
import axios from 'axios'

import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);

var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);


import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import store from '@/store/store.js'
//使用axios
Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.use(Element, { size: 'small' })

//图片懒加载
// Vue.use(VueLazyLoad,{
//     preLoad: 1.3,
//     error:'../static/images/mr.png',//显示错误图片
//     loading:'../static/images/mr.png',//正在加载中的图片
//     attempt: 1,
//     try: 2,
//     done:true
// })

//vue 美化滚动条插件
import EasyScroll from 'easyscroll';

Vue.use(EasyScroll);

//vue 百度地图插件
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'VBC48ThGEUWQpCOwjD4EAMHIOloi4AWS&s=1'
})


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js